<!-- Zweck: Stellt die HTML-Struktur für app not found component im Frontend bereit. -->
<div class="errorcontent">
  <div>
    <div class="errorlogobox">
      <img class="logo" src="{{cfg.domainconfig.logofilename}}"/>
    </div>


    <div class="errorbox">
      <h1>Nicht gefunden</h1>

      <hr>


      <h4>Die angeforderte Ressource wurde nicht gefunden.</h4>

      <hr>

      <button mat-flat-button routerLink="/" color="primary">
        Zum Dashboard
      </button>
    </div>
  </div>
</div>
